import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'
import { BaseButton } from 'app/components/common/BaseButton'
import { SvgCheckIcon, SvgCloseIcon } from 'app/assets/svg-assets'

import { BaseRow } from 'app/components/common/BaseRow'
import { WarehousePurchaseContext } from 'app/containers/InventoryManagement/WarehousePurchase/context'
import { useHook } from '../BuyInfo/hook'
import { CustomButton, PageFooter } from '../../create/styles'
import { StorePOStatusEnum } from 'app/common/enum'

const Footer = () => {
  const { t } = useTranslation()
  const { handleCreate, handleUpdate, isLoading, handleCancel } = useHook()
  const { form, discount, orders, warehousePurchaseDetail } = useContext(
    WarehousePurchaseContext,
  )

  const handleCreateAndUpdate = async () => {
    const values = await form?.getFieldsValue()
    if (warehousePurchaseDetail?._id) {
      await handleUpdate(values, orders, discount, warehousePurchaseDetail?._id)
    } else {
      await handleCreate(values, orders, discount, StorePOStatusEnum.PENDING)
    }
  }
  return (
    <PageFooter>
      <BaseRow justify="end" align={'middle'}>
        <BaseButton
          icon={<SvgCloseIcon />}
          onClick={async () => await handleCancel()}
        >
          {t(R.strings.cancel)}
        </BaseButton>
        <CustomButton
          icon={<SvgCheckIcon />}
          onClick={async () => await handleCreateAndUpdate()}
          loading={isLoading}
        >
          {t(R.strings.confirm)}
        </CustomButton>
      </BaseRow>
    </PageFooter>
  )
}

export default Footer
